if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        if (this.initialized) return;
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.initialized = true;
        const variantInput = this.variantIdInput;
        if (variantInput) variantInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? (this.submitButton.querySelector('span') || this.submitButton) : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        if (evt) evt.preventDefault();
        this.init();

        if (!this.submitButton) {
          this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('.product-form__submit');
          this.submitButtonText = this.submitButton ? (this.submitButton.querySelector('span') || this.submitButton) : null;
        }

        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        }

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData(this.form);
        const isBoxLed = (window.selectedBoxType === 'led') || (window.selectedBoxName && window.selectedBoxName.indexOf('Işıklı') !== -1);
        const hasRose = !!window.selectedHasRoseUpsell;
        const bundleQty = parseInt(window.selectedBundleQty || formData.get('quantity') || '1', 10) || 1;
        const orderNote = window.customCustomerOrderNote || formData.get('properties[Sipariş Notu]') || '';
        const mainVariantId = formData.get('id') || (this.form.querySelector('[name="id"]') ? this.form.querySelector('[name="id"]').value : null);
        const lightBoxVariantId = 64542897832305;
        const roseVariantId = 64589803422065;

        const mainProperties = {
          '_Kutu Seçimi': isBoxLed ? (bundleQty > 1 ? bundleQty + 'x ' : '1x ') + '✨ Işıklı Hediye Kutusu' : (bundleQty > 1 ? bundleQty + 'x ' : '1x ') + '🌸 Standart Pembe Kutu'
        };
        if (hasRose) {
          mainProperties['_Ek Hediye'] = (bundleQty > 1 ? bundleQty + 'x ' : '1x ') + '🌹 Tekli Kokulu Gül Kutusu';
        }
        if (orderNote) {
          mainProperties['_Sipariş Notu'] = orderNote;
        }

        const itemsToAdd = [];

        if (isBoxLed) {
          itemsToAdd.push({
            id: lightBoxVariantId,
            quantity: bundleQty
          });
        }

        if (hasRose) {
          itemsToAdd.push({
            id: roseVariantId,
            quantity: bundleQty
          });
        }

        if (mainVariantId) {
          itemsToAdd.push({
            id: parseInt(mainVariantId, 10),
            quantity: bundleQty,
            properties: mainProperties
          });
        }

        const payload = {
          items: itemsToAdd
        };

        const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
        const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status && response.status !== 200) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description || response.message || 'Ürün sepete eklenemedi.');

              const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', 'true');
                if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }

            // 1. Submit Button Immediate Visual Confirmation (✓ Sepete Eklendi!)
            if (this.submitButton) {
              const origButtonContent = this.submitButtonText ? this.submitButtonText.innerHTML : this.submitButton.innerHTML;
              this.submitButton.classList.add('btn-added-success');
              if (this.submitButtonText) {
                this.submitButtonText.innerHTML = '<span class="added-badge">✓ Sepete Eklendi!</span>';
              }
              
              // Also update sticky bar button if present
              const stickyBtn = document.getElementById('sticky-add-cart-btn');
              if (stickyBtn) {
                stickyBtn.classList.add('btn-added-success');
                setTimeout(() => { stickyBtn.classList.remove('btn-added-success'); }, 2500);
              }

              setTimeout(() => {
                this.submitButton.classList.remove('btn-added-success');
                if (this.submitButtonText) {
                  this.submitButtonText.innerHTML = origButtonContent;
                }
              }, 2500);
            }

            // 2. Instantly update header cart count bubble across all desktop & mobile elements
            fetch('/cart.js')
              .then((r) => r.json())
              .then((cartData) => {
                const count = (cartData && typeof cartData.item_count === 'number') ? cartData.item_count : 1;
                const cartLinks = document.querySelectorAll('#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href$="/cart"]');
                cartLinks.forEach((cartLink) => {
                  let bubble = cartLink.querySelector('.cart-count-bubble');
                  if (count > 0) {
                    if (bubble) {
                      bubble.style.setProperty('display', 'flex', 'important');
                      bubble.style.setProperty('visibility', 'visible', 'important');
                      bubble.style.setProperty('opacity', '1', 'important');
                      bubble.classList.remove('pulse-active');
                      void bubble.offsetWidth;
                      bubble.classList.add('pulse-active');
                      const span = bubble.querySelector('span:not(.visually-hidden)');
                      if (span) span.textContent = count;
                      else bubble.textContent = count;
                    } else {
                      bubble = document.createElement('div');
                      bubble.className = 'cart-count-bubble pulse-active';
                      bubble.style.setProperty('display', 'flex', 'important');
                      bubble.style.setProperty('visibility', 'visible', 'important');
                      bubble.style.setProperty('opacity', '1', 'important');
                      bubble.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + '</span>';
                      cartLink.appendChild(bubble);
                    }
                  }
                });

                const cartIcon = document.getElementById('cart-icon-bubble');
                if (cartIcon) {
                  cartIcon.style.transition = 'transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
                  cartIcon.style.transform = 'scale(1.25)';
                  setTimeout(() => { cartIcon.style.transform = 'scale(1)'; }, 280);
                }
              })
              .catch((err) => console.warn('Bubble update err:', err));

            // 3. Fetch rendered cart sections and render cart notification / drawer if present
            if (this.cart && typeof this.cart.renderContents === 'function') {
              const sectionsUrl = `${cartUrl}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer`;
              fetch(sectionsUrl)
                .then((r) => r.json())
                .then((sectionsData) => {
                  const combinedState = {
                    ...response,
                    sections: sectionsData,
                    key: (response.items && response.items.length > 0 ? response.items[0].key : (response.key || ''))
                  };

                  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !this.error) {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: combinedState,
                    });
                  }
                  this.error = false;

                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          if (this.cart && typeof this.cart.renderContents === 'function') {
                            this.cart.renderContents(combinedState);
                          }
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    if (this.cart && typeof this.cart.renderContents === 'function') {
                      this.cart.renderContents(combinedState);
                    }
                  }
                })
                .catch((err) => {
                  if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(response);
                  }
                });
            }
          })
          .catch((e) => {
            console.error('Cart add exception:', e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) {
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton ? (this.submitButton.querySelector('span') || this.submitButton) : null;
        }
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Sepete Ekle';
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : this.querySelector('[name=id]');
      }
    }
  );
}
